import { updateField } from "vuex-map-fields";
import { resetState } from "~/util/reset_store_state/reset_store_state";
import useState from "../../store/state";

const SET_FAMILY = (state, family) => {
  state.family = family;
};

const SET_FAMILY_ARRAY = (state) => {
  const familyArray = [];
  if ("main" in state.family) {
    familyArray.push(state.family.main.data);
  } else if ("partner" in state.family) {
    familyArray.push(state.family.partner.data);
  } else if ("children" in state.family) {
    state.family.children.data.forEach((customer) => familyArray.push(customer));
  }

  state.familyArray = familyArray;
};
const SET_FILTER_OPTIONS = (state, options) => {
  state.filterOptions = options;
};

const SET_FILTER = (state, filter) => {
  if (!filter) return;
  state.filter = filter;
};
const SET_FILTER_VALUE = (state, { code, value, type }) => {
  const clone = { ...state.filter };
  clone[type].mutation_codes[code] = value;
  state.filter = clone;
};
const SET_INITIAL_FILTER = (state) => {
  const mutationCodes = Object.keys(state.filterOptions);
  const clone = { ...state.filter };
  for (let i = 0; i < mutationCodes.length; i += 1) {
    clone.packages.mutation_codes[mutationCodes[i]] = true;
    clone.policies.mutation_codes[mutationCodes[i]] = true;
  }
  state.filter = clone;
};

const SET_INACTIVE_PACKAGES = (state, { packages, customerId }) => {
  const clone = { ...state.inactivePackages };
  clone[customerId] = packages;
  state.inactivePackages = clone;
};
const SET_ACTIVE_PACKAGES = (state, { packages, customerId }) => {
  const clone = { ...state.activePackages };
  clone[customerId] = packages;
  state.activePackages = clone;
};

const SET_POLICIES = (state, { policies, customerId }) => {
  const clone = { ...state.policies };
  clone[customerId] = policies;
  state.policies = clone;
};
const SET_PACKAGES = (state, { packages, customerId }) => {
  const clone = { ...state.packages };
  clone[customerId] = packages;
  state.packages = clone;
};
const SET_ACTIVE_CUSTOMER_ID = (state, id) => {
  state.activeCustomerId = id;
};

const SET_DISPLAY_STATE = (state, displayState) => {
  state.displayState = displayState;
};

const SET_FILTER_LOADED = (state, bool) => {
  state.filterLoaded = bool;
};
const SET_LOADING = (state, loading) => {
  state.loading = loading;
};

const SET_PACKAGE_COUNT = (state, count) => {
  state.packageCount = count;
};
const SET_POLICY_COUNT = (state, count) => {
  state.policyCount = count;
};

const CLEAR_ALL_PACKAGES_FILTERS = (state) => {
  const clone = { ...state.filter };
  clone.packages.mutation_codes.Vervallen = true;
  clone.packages.mutation_codes.Lopend = true;
  state.filter = clone;
};
const CLEAR_ALL_POLICIES_FILTERS = (state) => {
  const clone = { ...state.filter };
  clone.policies.mutation_codes.Vervallen = true;
  clone.policies.mutation_codes.Lopend = true;
  state.filter = clone;
};
export default {
  CLEAR_ALL_PACKAGES_FILTERS,
  CLEAR_ALL_POLICIES_FILTERS,
  SET_LOADING,
  SET_FAMILY,
  SET_PACKAGE_COUNT,
  SET_POLICY_COUNT,
  SET_PACKAGES,
  SET_POLICIES,
  SET_DISPLAY_STATE,
  SET_FILTER_VALUE,
  SET_FILTER_OPTIONS,
  SET_ACTIVE_CUSTOMER_ID,
  SET_FILTER,
  SET_INITIAL_FILTER,
  SET_FAMILY_ARRAY,
  SET_FILTER_LOADED,
  SET_ACTIVE_PACKAGES,
  SET_INACTIVE_PACKAGES,
  updateField,
  resetState: resetState(useState),
};
